// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"button_buttonWrapper__fhIBv","formSended":"button_formSended__q5Khe"};